import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {Provider} from 'react-redux';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import itLocale from 'date-fns/locale/it';
import { itIT } from '@mui/material/locale';
import store  from './store/index.js';

const mdTheme = createTheme(
  {
    typography: {
      fontFamily: 'Segoe UI'
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 990,
        lg: 1200,
        xl: 1536,
      }
    }
  },
  itIT
);

ReactDOM.render(
  <Provider store={store}>
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={itLocale}>
      <ThemeProvider theme={mdTheme}>
        <BrowserRouter> 
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </LocalizationProvider>
  </Provider>,
  document.getElementById('root')
);

reportWebVitals();
